import { render, staticRenderFns } from "./AdminCampaignDetails.vue?vue&type=template&id=b1ad8142&"
import script from "./AdminCampaignDetails.vue?vue&type=script&lang=ts&"
export * from "./AdminCampaignDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports